(function (angular) {
    angular.module('app.purchase').config([
        '$stateProvider',
        '$urlRouterProvider',
        function ($stateProvider, $urlRouterProvider) {
            $stateProvider
                .state('app.legacyPurchasePlans', {
                    url: '/purchase/plans',
                    controller: [
                        '$state',
                        function ($state) {
                            $state.go('app.purchase.plans');
                        }
                    ]
                })
                .state('app.legacyPurchaseApplicants', {
                    url: '/purchase/applicants',
                    controller: [
                        '$state',
                        function ($state) {
                            $state.go('app.purchase.applicants');
                        }
                    ]
                })
                .state('app.purchase', {
                    url: '/plans',
                    abstract: true,
                    templateUrl: '/app/site/purchase-flow/purchase-flow.template.html',
                    controller: 'app.purchase.PurchaseFlowController',
                    controllerAs: 'vmPurchaseFlow'
                })
                .state('app.purchase.plans', {
                    url: '',
                    templateUrl: '/app/site/purchase-flow/choose-plan/choose-plan.html',
                    controller: 'app.purchase.ChoosePlanController',
                    controllerAs: 'vm'
                })
                .state('app.purchase.applicants', {
                    url: '/application',
                    templateUrl: '/app/site/purchase-flow/applicant-info/applicant-info.template.html',
                    controller: 'app.purchase.ApplicantInfoController',
                    controllerAs: 'vm',
                    resolve: {
                        purchase: [
                            'app.purchase.purchaseFlowService',
                            '$state',
                            'ui',
                            function (purchaseFlowService, $state, ui) {
                                ui.block();
                                return purchaseFlowService
                                    .getPurchase()
                                    .then(function (purchase) {
                                        if (!purchase.coverageLevelName) {
                                            setTimeout(function () {
                                                $state.go('app.purchase.plans');
                                            });
                                            throw 'A plan must be selected first.';
                                        }
                                        return purchase;
                                    })
                                    .finally(function () {
                                        ui.unblock();
                                    });
                            }
                        ]
                    }
                })
                .state('app.purchase.responsibleParty', {
                    url: '/application',
                    templateUrl: '/app/site/purchase-flow/responsible-party-info/responsible-party-info.template.html',
                    controller: 'app.purchase.ResponsiblePartyInfoController',
                    controllerAs: 'vm',
                    resolve: {
                        purchase: [
                            'app.purchase.purchaseFlowService',
                            '$state',
                            'ui',
                            function (purchaseFlowService, $state, ui) {
                                ui.block();
                                return purchaseFlowService
                                    .getPurchase()
                                    .then(function (purchase) {
                                        if (!purchase.coverageLevelName) {
                                            setTimeout(function () {
                                                $state.go('app.purchase.plans');
                                            });
                                            throw 'A plan must be selected first.';
                                        }
                                        return purchase;
                                    })
                                    .finally(function () {
                                        ui.unblock();
                                    });
                            }
                        ]
                    }
                })
                .state('app.purchase.payment', {
                    url: '/payment',
                    templateUrl: '/app/site/purchase-flow/payment-info/payment-info.template.html',
                    controller: 'app.purchase.PaymentInfoController',
                    controllerAs: 'vm',
                    resolve: {
                        purchase: [
                            'app.purchase.purchaseFlowService',
                            '$state',
                            'ui',
                            function (purchaseFlowService, $state, ui) {
                                ui.block();
                                return purchaseFlowService
                                    .getPurchase()
                                    .then(function (data) {
                                        try {
                                            if (!data.coverageLevelName) {
                                                throw 'A plan must be selected first.';
                                            }
                                            if (!data.primaryApplicant) {
                                                throw 'An applicant must be entered first.';
                                            }

                                            var numMembers = 1;
                                            if (data.associatedApplicants) {
                                                numMembers += data.associatedApplicants.length;
                                            }

                                            if (data.minNumberMembers > numMembers) {
                                                throw 'This plan requires associated applicants to be entered first.';
                                            }

                                            data.paymentInfo = null;
                                            return data;
                                        } catch (e) {
                                            setTimeout(function () {
                                                $state.go('app.purchase.applicants');
                                            });
                                            throw e;
                                        }
                                    })
                                    .finally(function () {
                                        ui.unblock();
                                    });
                            }
                        ]
                    }
                })
                .state('app.purchase.activated', {
                    url: '/activated',
                    templateUrl: '/app/site/purchase-flow/activated/activated.template.html',
                    controller: 'app.purchase.activatedController',
                    controllerAs: 'vm',
                    resolve: {
                        purchase: [
                            'app.purchase.purchaseFlowService',
                            '$state',
                            'ui',
                            function (purchaseFlowService, $state, ui) {
                                ui.block();
                                return purchaseFlowService
                                    .getPurchase(true)
                                    .then(function (purchase) {
                                        if (!purchase.completed || typeof purchase.completed == 'undefined' || purchase.completed == null) {
                                            setTimeout(function () {
                                                $state.go('app.purchase.plans');
                                            });
                                            throw 'A plan must be complete.';
                                        }
                                        else if (!purchase.coverageLevelName) {
                                            setTimeout(function () {
                                                $state.go('app.purchase.plans');
                                            });
                                            throw 'A plan must be selected first.';
                                        }
                                        return purchase;
                                    })
                                    .finally(function () {
                                        ui.unblock();
                                    });
                            }
                        ]
                    },
                    isShowProgressbar: false
                });

            $urlRouterProvider.when('/purchase', '/purchase/plans');

            function goToCurrentOrDefault($state) {
                if (!$state.current.name) {
                    $state.go('app.purchase.plans');
                } else {
                    $state.go($state.current.name);
                }
            }
        }
    ]);
})(angular);